/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import 'react-infinite-calendar/styles.css';
import { withRouter } from 'react-router';
import { translate } from 'react-i18next';

/**
 * Actions
 */
import {
  uploadDatasetAssetMetering,
  datasetAssetMeteringChanged,
  uploadDatasetAssetMeteringStart,
} from '../../actions';

/**
 * Common component import
 */
import LoadingCircle from '../commons/LoadingCircle';

const styles = theme => ({});

class UploadAssetMetering extends React.Component {
  onDropAssetMeteringFile = async file => {
    this.props.uploadDatasetAssetMetering(file);
  };

  handleDatasetAssetMeteringChange = event => {
    this.props.datasetAssetMeteringChanged(event.target.files[0]);
  };

  render() {
    const { classes, t } = this.props;

    return (
      <div className={classes.root}>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader title={t('Data Asset Metering uploader')} />
          <CardContent>
            <Grid item xs={12}>
              <Row>
                <Col xs={12}>
                  <div style={{ float: 'left' }}>
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      className={classes.input}
                      id="upload-asset-metering-button-file"
                      multiple
                      type="file"
                      style={{ display: 'none' }}
                      onChange={this.handleDatasetAssetMeteringChange.bind(
                        this
                      )}
                      onDrop={this.onDropAssetMeteringFile.bind(this)}
                    />
                    <label htmlFor="upload-asset-metering-button-file">
                      <Button
                        variant="outlined"
                        color="primary"
                        component="span"
                        className={classes.button}
                        disabled={this.props.loadingDatasetAssetMetering}
                        style={{
                          marginTop: 13,
                          border: '1px solid rgba(248,119,51, 0.5)',
                          borderRadius: 4,
                        }}
                      >
                        Select Asset Metering Dataset
                      </Button>
                    </label>
                  </div>
                  <div style={{ float: 'left', marginTop: 24 }}>
                    <Typography
                      variant="caption"
                      style={{ color: 'rgba(0, 0, 0, 0.54)', marginLeft: 10 }}
                    >
                      {this.props.localDatasetAssetMetering &&
                      this.props.localDatasetAssetMetering.name
                        ? this.props.localDatasetAssetMetering.name
                        : 'No file selected'}
                    </Typography>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <Col xs={12}>
                  <Button
                    variant="raised"
                    color="primary"
                    disabled={
                      this.props.loadingDatasetAssetMetering ||
                      !this.props.localDatasetAssetMetering ||
                      !this.props.localDatasetAssetMetering.name
                    }
                    onClick={() => {
                      this.props.uploadDatasetAssetMeteringStart(
                        this.props.localDatasetAssetMetering
                      );
                    }}
                  >
                    Upload Asset Metering dataset
                  </Button>
                  {this.props.loadingDatasetAssetMetering && (
                    <LoadingCircle type="buttonProgress" classes={classes} />
                  )}
                </Col>
              </Row>
              <div />
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({ uploadAssetMeteringReducer }) => {
  const {
    localDatasetAssetMetering,
    loadingDatasetAssetMetering,
  } = uploadAssetMeteringReducer;

  return {
    localDatasetAssetMetering,
    loadingDatasetAssetMetering,
  };
};

const mapDispatchToProps = {
  // Upload asset metering
  uploadDatasetAssetMetering,
  datasetAssetMeteringChanged,
  uploadDatasetAssetMeteringStart,
};

UploadAssetMetering = withStyles(styles, { name: 'Maintenance' })(
  UploadAssetMetering
);
UploadAssetMetering = translate('translations')(UploadAssetMetering);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UploadAssetMetering)
);



// WEBPACK FOOTER //
// ./src/components/Maintenance/UploadAssetMetering.js